import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';

import { Options } from './api';
import { ConsentClient } from './client';

const selectConsent = () => ConsentClient.consent;
export const useConsent = () => {
	const consent = useSyncExternalStore(ConsentClient.subscribe, selectConsent);

	return consent;
};

const selectAllows = (key: string) => () => Boolean(ConsentClient.allows(key));
export const useHasConsent = (key: string) => {
	const allows = useSyncExternalStore(ConsentClient.subscribe, selectAllows(key));

	return allows;
};

const selectPending = () => ConsentClient.isConsentPending;
export const useIsConsentPending = () => {
	const isConsentPending = useSyncExternalStore(ConsentClient.subscribe, selectPending);

	return isConsentPending;
};

export const useGiveConsent = () => {
	const give = useCallback((permissions: Record<string, boolean>) => {
		ConsentClient.giveConsent(permissions);
	}, []);
	return give;
};

export const useConsentOptions = () => {
	const [options, setOptions] = useState<Options | null>(null);

	useEffect(() => {
		ConsentClient.getOptions().then((data) => setOptions(data));
	}, []);

	return options;
};
